import React from "react";

const Hero = ({home}) => {
  return (
    <div>
      <div
        id="rs-slider"
        class="rs-slider-banner images-overlay rs-slider-banner5"
      >
        <div id="home-banner">
          <div class="item active">
            <img
              src="https://static.vecteezy.com/system/resources/previews/008/680/961/non_2x/abstract-technology-background-free-vector.jpg"
              alt=""
            />
            <div class="slide-content">
              <div class="display-table">
                <div class="display-table-cell">
                  <div class="container">
                    <div class="row">
                      <div class="col-lg-12">
                        <div class="banner-counter5">
                          <div class="timecounter-inner">
                            <div class="coming-soon-part">
                              <div class="coming-soon-text">
                                <div
                                  data-animation-in="slideInLeft"
                                  data-animation-out="animate-out fadeOut"
                                  class="CountDownTimer3"
                                  data-date="2025-08-29 00:00:00"
                                ></div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="banner-content text-center">
                          <h1
                            class="slider-title"
                            data-animation-in="fadeInLeft"
                            data-animation-out="animate-out"
                          >
                            {home.acroynm[0].text}
                          </h1>


                          <div
                            data-animation-in="fadeInUp"
                            data-animation-out="animate-out"
                            class="slider-desc"
                          >
                            <h2 className="text-white">
                              {home.title[0].text}
                              <br />
                              {/* <h3 className="text-white">
                                Technically Sponsered By IEEE Delhi Section
                              </h3> */}
                            </h2>
                          </div>
                          {/* <h5 className="text-white">at</h5> */}
                          <div
                            data-animation-in="fadeInUp"
                            data-animation-out="animate-out"
                            class="slider-desc"
                          >
                            <h4 className="text-white">
                            {home.oragnized[0].text}
                            </h4>
                            <p className="lead">(Hybrid Mode)</p>
                          </div>
                          <div class="date-meta">
                            <span>
                              <i class="fa fa-calendar" aria-hidden="true"></i>{" "}
                              {home.conference_date[0].text}
                            </span>
                            <div className="cflex">
                              <p class="su-btn">
                                <a href={home.paper_submission_link[0].text}>
                                  Submit Paper
                                </a>
                              </p>
                              <p class="su-btn">
                                <a href={home.registration_link[0].text}>
                                  Registration
                                </a>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="slider-shape2"></div>
      </div>
    </div>
  );
};

export default Hero;
